export default __webpack_public_path__ + "static/media/info.46d9d520.svg";